import { API_METHOD, authApiClient } from '../../../api';
import {
  handleLoadProductDetailBanners,
  removeProductDetailBanner,
  upsertProductDetailBanner,
} from './productDetailBanners';

export const LOAD_PRODUCT_DETAIL_BANNER = 'productDetailBanner/LOAD_PRODUCT_DETAIL_BANNER';
export const RESET_PRODUCT_DETAIL_BANNER = 'productDetailBanner/RESET_PRODUCT_DETAIL_BANNER';

const initialState = null;

export const loadProductDetailBanner = banner => ({
  type: LOAD_PRODUCT_DETAIL_BANNER,
  banner,
});

export const resetProductDetailBanner = () => ({
  type: RESET_PRODUCT_DETAIL_BANNER,
});

const notifyFailure = error => {
  alert(error.message);
  return false;
};

export const handleLoadProductDetailBanner = (bannerId, shouldApply = () => true) => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.GET, `banner/product-detail/${bannerId}`, undefined);
      if (!shouldApply()) return false;

      dispatch(loadProductDetailBanner(response.data.result));
      return true;
    } catch (error) {
      if (!shouldApply()) return false;

      return notifyFailure(error);
    }
  };
};

export const handleSaveProductDetailBanner = (banner, onSuccess, shouldApply = () => true) => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.POST, 'banner/product-detail', banner);
      if (!shouldApply()) return true;

      dispatch(upsertProductDetailBanner(response.data.result));
      await dispatch(handleLoadProductDetailBanners(shouldApply, { notifyOnError: false }));
      if (!shouldApply()) return true;

      if (onSuccess) onSuccess(response.data.result);
      return true;
    } catch (error) {
      if (!shouldApply()) return false;

      return notifyFailure(error);
    }
  };
};

export const handleUpdateProductDetailBanner = (bannerId, banner, onSuccess, shouldApply = () => true) => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.PATCH, `banner/product-detail/${bannerId}`, banner);
      if (!shouldApply()) return true;

      dispatch(upsertProductDetailBanner(response.data.result));
      await dispatch(handleLoadProductDetailBanners(shouldApply, { notifyOnError: false }));
      if (!shouldApply()) return true;

      if (onSuccess) onSuccess(response.data.result);
      return true;
    } catch (error) {
      if (!shouldApply()) return false;

      return notifyFailure(error);
    }
  };
};

export const handleDeleteProductDetailBanner = (bannerId, onSuccess, shouldApply = () => true) => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.DELETE, `banner/product-detail/${bannerId}`, undefined);
      if (!shouldApply()) return true;

      dispatch(removeProductDetailBanner(bannerId));
      await dispatch(handleLoadProductDetailBanners(shouldApply, { notifyOnError: false }));
      if (!shouldApply()) return true;

      if (onSuccess) onSuccess(response.data.result);
      return true;
    } catch (error) {
      if (!shouldApply()) return false;

      return notifyFailure(error);
    }
  };
};

export default function productDetailBanner(state = initialState, action) {
  switch (action.type) {
    case LOAD_PRODUCT_DETAIL_BANNER:
      return action.banner;
    case RESET_PRODUCT_DETAIL_BANNER:
      return initialState;
    default:
      return state;
  }
}
